// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4d37e57c","900":"82161ee2"}[chunkId] + ".chunk.js";
};